import { makeApi } from "@zodios/core";
import { z } from "zod";

import { refSiteLayoutDtoSchema } from "@/types/backoffice/dto/reference/ref-site-layout-dto.ts";
import { refSiteTypeDtoSchema } from "@/types/backoffice/dto/reference/ref-site-type-dto.ts";
import { supportTypeDtoSchema } from "@/types/backoffice/dto/reference/support-type-dto.ts";

export const backofficeReferenceApi = makeApi([
  {
    method: "get",
    path: "/typeSupport",
    response: z.array(supportTypeDtoSchema),
    alias: "findSupportTypes",
  },
  {
    method: "get",
    path: "/siteTypeRef",
    response: z.array(refSiteTypeDtoSchema),
    alias: "findAllSiteTypeRef",
  },
  {
    method: "get",
    path: "/siteLayout",
    response: z.array(refSiteLayoutDtoSchema),
    alias: "findAllSiteLayoutRef",
  },
]);
